/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { AdminGetExchangeCancelCategoriesInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetExchangeCancelCategoriesOkDto } from '../../src/model';
// @ts-ignore
import type { AdminGetExchangeCancelCategoriesResponse } from '../../src/model';
// @ts-ignore
import type { AdminGetExchangeResponse } from '../../src/model';
// @ts-ignore
import type { AdminGetExchangesInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetExchangesOkDto } from '../../src/model';
// @ts-ignore
import type { AdminGetExchangesXlsxInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetExchangesXlsxResponse } from '../../src/model';
// @ts-ignore
import type { AdminPatchStatusApplicationToCompletedForbiddenDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchStatusExchangeCancelCategoryMissingConflictDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchStatusExchangeCancelOtherReasonMissingConflictDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchStatusInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchStatusLogicErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchStatusOkDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchStatusReqBodyDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchStatusRequestDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchStatusRequestStatusIsApplicationForbiddenDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchStatusResponse } from '../../src/model';
// @ts-ignore
import type { AdminPatchStatusStatusIsCompletedForbiddenDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchStatusStatusIsImpossibleForbiddenDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchStatusToImpossibleDto } from '../../src/model';
// @ts-ignore
import type { JwtAdminAccessGuardUnauthorizedDto } from '../../src/model';
/**
 * AdminExchangeApi - axios parameter creator
 * @export
 */
export const AdminExchangeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 어드민 환급불가 사유 조회
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminExchangeControllerAdminGetExchangeCancelCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/exchange/cancel-category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 환급 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {AdminExchangeControllerAdminGetExchangesStatusEnum} [status] 알림 상태
         * @param {string} [startDate] 시작 날짜
         * @param {string} [endDate] 끝 날짜
         * @param {AdminExchangeControllerAdminGetExchangesSortEnum} [sort] 정렬 기준
         * @param {AdminExchangeControllerAdminGetExchangesSortOrderEnum} [sortOrder] 정렬 순서
         * @param {AdminExchangeControllerAdminGetExchangesSearchTypeEnum} [searchType] 검색 타입
         * @param {string} [keyword] 검색어(뷰업 ID)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminExchangeControllerAdminGetExchanges: async (page?: number, limit?: number, status?: AdminExchangeControllerAdminGetExchangesStatusEnum, startDate?: string, endDate?: string, sort?: AdminExchangeControllerAdminGetExchangesSortEnum, sortOrder?: AdminExchangeControllerAdminGetExchangesSortOrderEnum, searchType?: AdminExchangeControllerAdminGetExchangesSearchTypeEnum, keyword?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/exchange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchType !== undefined) {
                localVarQueryParameter['searchType'] = searchType;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 환급 로그 엑셀 다운로드
         * @param {AdminExchangeControllerAdminGetExchangesXlsxStatusEnum} [status] 알림 상태
         * @param {string} [startDate] 시작 날짜
         * @param {string} [endDate] 끝 날짜
         * @param {AdminExchangeControllerAdminGetExchangesXlsxSearchTypeEnum} [searchType] 검색 타입
         * @param {string} [keyword] 검색어(뷰업 ID)
         * @param {AdminExchangeControllerAdminGetExchangesXlsxSortEnum} [sort] 정렬 기준
         * @param {AdminExchangeControllerAdminGetExchangesXlsxSortOrderEnum} [sortOrder] 정렬 순서
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminExchangeControllerAdminGetExchangesXlsx: async (status?: AdminExchangeControllerAdminGetExchangesXlsxStatusEnum, startDate?: string, endDate?: string, searchType?: AdminExchangeControllerAdminGetExchangesXlsxSearchTypeEnum, keyword?: string, sort?: AdminExchangeControllerAdminGetExchangesXlsxSortEnum, sortOrder?: AdminExchangeControllerAdminGetExchangesXlsxSortOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/exchange/xlsx`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (searchType !== undefined) {
                localVarQueryParameter['searchType'] = searchType;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 환급 상태 변경
         * @param {AdminPatchStatusReqBodyDto} adminPatchStatusReqBodyDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminExchangeControllerAdminPatchStatus: async (adminPatchStatusReqBodyDto: AdminPatchStatusReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminPatchStatusReqBodyDto' is not null or undefined
            assertParamExists('adminExchangeControllerAdminPatchStatus', 'adminPatchStatusReqBodyDto', adminPatchStatusReqBodyDto)
            const localVarPath = `/admin/exchange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPatchStatusReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 환급 조회 API
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {AdminGetExchangeStatusEnum} [status] 알림 상태
         * @param {string} [startDate] 시작 날짜
         * @param {string} [endDate] 끝 날짜
         * @param {AdminGetExchangeSortEnum} [sort] 정렬 기준
         * @param {AdminGetExchangeSortOrderEnum} [sortOrder] 정렬 순서
         * @param {AdminGetExchangeSearchTypeEnum} [searchType] 검색 타입
         * @param {string} [keyword] 검색어(뷰업 ID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetExchange: async (page?: number, limit?: number, status?: AdminGetExchangeStatusEnum, startDate?: string, endDate?: string, sort?: AdminGetExchangeSortEnum, sortOrder?: AdminGetExchangeSortOrderEnum, searchType?: AdminGetExchangeSearchTypeEnum, keyword?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/admin/exchange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchType !== undefined) {
                localVarQueryParameter['searchType'] = searchType;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 환급불가 사유 조회 API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetExchangeCancelCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/admin/exchange/cancel-category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 환급 로그 엑셀 다운로드 API
         * @param {AdminGetExchangesXlsxStatusEnum} [status] 알림 상태
         * @param {string} [startDate] 시작 날짜
         * @param {string} [endDate] 끝 날짜
         * @param {AdminGetExchangesXlsxSearchTypeEnum} [searchType] 검색 타입
         * @param {string} [keyword] 검색어(뷰업 ID)
         * @param {AdminGetExchangesXlsxSortEnum} [sort] 정렬 기준
         * @param {AdminGetExchangesXlsxSortOrderEnum} [sortOrder] 정렬 순서
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetExchangesXlsx: async (status?: AdminGetExchangesXlsxStatusEnum, startDate?: string, endDate?: string, searchType?: AdminGetExchangesXlsxSearchTypeEnum, keyword?: string, sort?: AdminGetExchangesXlsxSortEnum, sortOrder?: AdminGetExchangesXlsxSortOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/admin/exchange/xlsx`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (searchType !== undefined) {
                localVarQueryParameter['searchType'] = searchType;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 환급 상태 변경 API
         * @param {AdminPatchStatusRequestDto} adminPatchStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPatchStatus: async (adminPatchStatusRequestDto: AdminPatchStatusRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminPatchStatusRequestDto' is not null or undefined
            assertParamExists('adminPatchStatus', 'adminPatchStatusRequestDto', adminPatchStatusRequestDto)
            const localVarPath = `/v1/admin/exchange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPatchStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminExchangeApi - functional programming interface
 * @export
 */
export const AdminExchangeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminExchangeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 어드민 환급불가 사유 조회
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async adminExchangeControllerAdminGetExchangeCancelCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetExchangeCancelCategoriesOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminExchangeControllerAdminGetExchangeCancelCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminExchangeApi.adminExchangeControllerAdminGetExchangeCancelCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 환급 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {AdminExchangeControllerAdminGetExchangesStatusEnum} [status] 알림 상태
         * @param {string} [startDate] 시작 날짜
         * @param {string} [endDate] 끝 날짜
         * @param {AdminExchangeControllerAdminGetExchangesSortEnum} [sort] 정렬 기준
         * @param {AdminExchangeControllerAdminGetExchangesSortOrderEnum} [sortOrder] 정렬 순서
         * @param {AdminExchangeControllerAdminGetExchangesSearchTypeEnum} [searchType] 검색 타입
         * @param {string} [keyword] 검색어(뷰업 ID)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async adminExchangeControllerAdminGetExchanges(page?: number, limit?: number, status?: AdminExchangeControllerAdminGetExchangesStatusEnum, startDate?: string, endDate?: string, sort?: AdminExchangeControllerAdminGetExchangesSortEnum, sortOrder?: AdminExchangeControllerAdminGetExchangesSortOrderEnum, searchType?: AdminExchangeControllerAdminGetExchangesSearchTypeEnum, keyword?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetExchangesOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminExchangeControllerAdminGetExchanges(page, limit, status, startDate, endDate, sort, sortOrder, searchType, keyword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminExchangeApi.adminExchangeControllerAdminGetExchanges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 환급 로그 엑셀 다운로드
         * @param {AdminExchangeControllerAdminGetExchangesXlsxStatusEnum} [status] 알림 상태
         * @param {string} [startDate] 시작 날짜
         * @param {string} [endDate] 끝 날짜
         * @param {AdminExchangeControllerAdminGetExchangesXlsxSearchTypeEnum} [searchType] 검색 타입
         * @param {string} [keyword] 검색어(뷰업 ID)
         * @param {AdminExchangeControllerAdminGetExchangesXlsxSortEnum} [sort] 정렬 기준
         * @param {AdminExchangeControllerAdminGetExchangesXlsxSortOrderEnum} [sortOrder] 정렬 순서
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async adminExchangeControllerAdminGetExchangesXlsx(status?: AdminExchangeControllerAdminGetExchangesXlsxStatusEnum, startDate?: string, endDate?: string, searchType?: AdminExchangeControllerAdminGetExchangesXlsxSearchTypeEnum, keyword?: string, sort?: AdminExchangeControllerAdminGetExchangesXlsxSortEnum, sortOrder?: AdminExchangeControllerAdminGetExchangesXlsxSortOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminExchangeControllerAdminGetExchangesXlsx(status, startDate, endDate, searchType, keyword, sort, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminExchangeApi.adminExchangeControllerAdminGetExchangesXlsx']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 환급 상태 변경
         * @param {AdminPatchStatusReqBodyDto} adminPatchStatusReqBodyDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async adminExchangeControllerAdminPatchStatus(adminPatchStatusReqBodyDto: AdminPatchStatusReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPatchStatusOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminExchangeControllerAdminPatchStatus(adminPatchStatusReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminExchangeApi.adminExchangeControllerAdminPatchStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 환급 조회 API
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {AdminGetExchangeStatusEnum} [status] 알림 상태
         * @param {string} [startDate] 시작 날짜
         * @param {string} [endDate] 끝 날짜
         * @param {AdminGetExchangeSortEnum} [sort] 정렬 기준
         * @param {AdminGetExchangeSortOrderEnum} [sortOrder] 정렬 순서
         * @param {AdminGetExchangeSearchTypeEnum} [searchType] 검색 타입
         * @param {string} [keyword] 검색어(뷰업 ID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetExchange(page?: number, limit?: number, status?: AdminGetExchangeStatusEnum, startDate?: string, endDate?: string, sort?: AdminGetExchangeSortEnum, sortOrder?: AdminGetExchangeSortOrderEnum, searchType?: AdminGetExchangeSearchTypeEnum, keyword?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetExchangeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetExchange(page, limit, status, startDate, endDate, sort, sortOrder, searchType, keyword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminExchangeApi.adminGetExchange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 환급불가 사유 조회 API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetExchangeCancelCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetExchangeCancelCategoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetExchangeCancelCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminExchangeApi.adminGetExchangeCancelCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 환급 로그 엑셀 다운로드 API
         * @param {AdminGetExchangesXlsxStatusEnum} [status] 알림 상태
         * @param {string} [startDate] 시작 날짜
         * @param {string} [endDate] 끝 날짜
         * @param {AdminGetExchangesXlsxSearchTypeEnum} [searchType] 검색 타입
         * @param {string} [keyword] 검색어(뷰업 ID)
         * @param {AdminGetExchangesXlsxSortEnum} [sort] 정렬 기준
         * @param {AdminGetExchangesXlsxSortOrderEnum} [sortOrder] 정렬 순서
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetExchangesXlsx(status?: AdminGetExchangesXlsxStatusEnum, startDate?: string, endDate?: string, searchType?: AdminGetExchangesXlsxSearchTypeEnum, keyword?: string, sort?: AdminGetExchangesXlsxSortEnum, sortOrder?: AdminGetExchangesXlsxSortOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetExchangesXlsxResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetExchangesXlsx(status, startDate, endDate, searchType, keyword, sort, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminExchangeApi.adminGetExchangesXlsx']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 환급 상태 변경 API
         * @param {AdminPatchStatusRequestDto} adminPatchStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPatchStatus(adminPatchStatusRequestDto: AdminPatchStatusRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPatchStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPatchStatus(adminPatchStatusRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminExchangeApi.adminPatchStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminExchangeApi - factory interface
 * @export
 */
export const AdminExchangeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminExchangeApiFp(configuration)
    return {
        /**
         * 
         * @summary 어드민 환급불가 사유 조회
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminExchangeControllerAdminGetExchangeCancelCategories(options?: RawAxiosRequestConfig): AxiosPromise<AdminGetExchangeCancelCategoriesOkDto> {
            return localVarFp.adminExchangeControllerAdminGetExchangeCancelCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 환급 조회
         * @param {AdminExchangeApiAdminExchangeControllerAdminGetExchangesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminExchangeControllerAdminGetExchanges(requestParameters: AdminExchangeApiAdminExchangeControllerAdminGetExchangesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetExchangesOkDto> {
            return localVarFp.adminExchangeControllerAdminGetExchanges(requestParameters.page, requestParameters.limit, requestParameters.status, requestParameters.startDate, requestParameters.endDate, requestParameters.sort, requestParameters.sortOrder, requestParameters.searchType, requestParameters.keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 환급 로그 엑셀 다운로드
         * @param {AdminExchangeApiAdminExchangeControllerAdminGetExchangesXlsxRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminExchangeControllerAdminGetExchangesXlsx(requestParameters: AdminExchangeApiAdminExchangeControllerAdminGetExchangesXlsxRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminExchangeControllerAdminGetExchangesXlsx(requestParameters.status, requestParameters.startDate, requestParameters.endDate, requestParameters.searchType, requestParameters.keyword, requestParameters.sort, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 환급 상태 변경
         * @param {AdminExchangeApiAdminExchangeControllerAdminPatchStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminExchangeControllerAdminPatchStatus(requestParameters: AdminExchangeApiAdminExchangeControllerAdminPatchStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPatchStatusOkDto> {
            return localVarFp.adminExchangeControllerAdminPatchStatus(requestParameters.adminPatchStatusReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 환급 조회 API
         * @param {AdminExchangeApiAdminGetExchangeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetExchange(requestParameters: AdminExchangeApiAdminGetExchangeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetExchangeResponse> {
            return localVarFp.adminGetExchange(requestParameters.page, requestParameters.limit, requestParameters.status, requestParameters.startDate, requestParameters.endDate, requestParameters.sort, requestParameters.sortOrder, requestParameters.searchType, requestParameters.keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 환급불가 사유 조회 API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetExchangeCancelCategories(options?: RawAxiosRequestConfig): AxiosPromise<AdminGetExchangeCancelCategoriesResponse> {
            return localVarFp.adminGetExchangeCancelCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 환급 로그 엑셀 다운로드 API
         * @param {AdminExchangeApiAdminGetExchangesXlsxRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetExchangesXlsx(requestParameters: AdminExchangeApiAdminGetExchangesXlsxRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetExchangesXlsxResponse> {
            return localVarFp.adminGetExchangesXlsx(requestParameters.status, requestParameters.startDate, requestParameters.endDate, requestParameters.searchType, requestParameters.keyword, requestParameters.sort, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 환급 상태 변경 API
         * @param {AdminExchangeApiAdminPatchStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPatchStatus(requestParameters: AdminExchangeApiAdminPatchStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPatchStatusResponse> {
            return localVarFp.adminPatchStatus(requestParameters.adminPatchStatusRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminExchangeControllerAdminGetExchanges operation in AdminExchangeApi.
 * @export
 * @interface AdminExchangeApiAdminExchangeControllerAdminGetExchangesRequest
 */
export interface AdminExchangeApiAdminExchangeControllerAdminGetExchangesRequest {
    /**
     * 현재 페이지
     * @type {number}
     * @memberof AdminExchangeApiAdminExchangeControllerAdminGetExchanges
     */
    readonly page?: number

    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof AdminExchangeApiAdminExchangeControllerAdminGetExchanges
     */
    readonly limit?: number

    /**
     * 알림 상태
     * @type {'application' | 'waiting' | 'completed' | 'impossible'}
     * @memberof AdminExchangeApiAdminExchangeControllerAdminGetExchanges
     */
    readonly status?: AdminExchangeControllerAdminGetExchangesStatusEnum

    /**
     * 시작 날짜
     * @type {string}
     * @memberof AdminExchangeApiAdminExchangeControllerAdminGetExchanges
     */
    readonly startDate?: string

    /**
     * 끝 날짜
     * @type {string}
     * @memberof AdminExchangeApiAdminExchangeControllerAdminGetExchanges
     */
    readonly endDate?: string

    /**
     * 정렬 기준
     * @type {'level' | 'exchangeableAmountBeforeRequest' | 'amountRequested' | 'tax' | 'amountBeExchanged' | 'createdAt' | 'balance' | 'exchangeAt'}
     * @memberof AdminExchangeApiAdminExchangeControllerAdminGetExchanges
     */
    readonly sort?: AdminExchangeControllerAdminGetExchangesSortEnum

    /**
     * 정렬 순서
     * @type {'desc' | 'asc'}
     * @memberof AdminExchangeApiAdminExchangeControllerAdminGetExchanges
     */
    readonly sortOrder?: AdminExchangeControllerAdminGetExchangesSortOrderEnum

    /**
     * 검색 타입
     * @type {'id' | 'name'}
     * @memberof AdminExchangeApiAdminExchangeControllerAdminGetExchanges
     */
    readonly searchType?: AdminExchangeControllerAdminGetExchangesSearchTypeEnum

    /**
     * 검색어(뷰업 ID)
     * @type {string}
     * @memberof AdminExchangeApiAdminExchangeControllerAdminGetExchanges
     */
    readonly keyword?: string
}

/**
 * Request parameters for adminExchangeControllerAdminGetExchangesXlsx operation in AdminExchangeApi.
 * @export
 * @interface AdminExchangeApiAdminExchangeControllerAdminGetExchangesXlsxRequest
 */
export interface AdminExchangeApiAdminExchangeControllerAdminGetExchangesXlsxRequest {
    /**
     * 알림 상태
     * @type {'application' | 'waiting' | 'completed' | 'impossible'}
     * @memberof AdminExchangeApiAdminExchangeControllerAdminGetExchangesXlsx
     */
    readonly status?: AdminExchangeControllerAdminGetExchangesXlsxStatusEnum

    /**
     * 시작 날짜
     * @type {string}
     * @memberof AdminExchangeApiAdminExchangeControllerAdminGetExchangesXlsx
     */
    readonly startDate?: string

    /**
     * 끝 날짜
     * @type {string}
     * @memberof AdminExchangeApiAdminExchangeControllerAdminGetExchangesXlsx
     */
    readonly endDate?: string

    /**
     * 검색 타입
     * @type {'id' | 'name'}
     * @memberof AdminExchangeApiAdminExchangeControllerAdminGetExchangesXlsx
     */
    readonly searchType?: AdminExchangeControllerAdminGetExchangesXlsxSearchTypeEnum

    /**
     * 검색어(뷰업 ID)
     * @type {string}
     * @memberof AdminExchangeApiAdminExchangeControllerAdminGetExchangesXlsx
     */
    readonly keyword?: string

    /**
     * 정렬 기준
     * @type {'level' | 'exchangeableAmountBeforeRequest' | 'amountRequested' | 'tax' | 'amountBeExchanged' | 'createdAt' | 'balance' | 'exchangeAt'}
     * @memberof AdminExchangeApiAdminExchangeControllerAdminGetExchangesXlsx
     */
    readonly sort?: AdminExchangeControllerAdminGetExchangesXlsxSortEnum

    /**
     * 정렬 순서
     * @type {'desc' | 'asc'}
     * @memberof AdminExchangeApiAdminExchangeControllerAdminGetExchangesXlsx
     */
    readonly sortOrder?: AdminExchangeControllerAdminGetExchangesXlsxSortOrderEnum
}

/**
 * Request parameters for adminExchangeControllerAdminPatchStatus operation in AdminExchangeApi.
 * @export
 * @interface AdminExchangeApiAdminExchangeControllerAdminPatchStatusRequest
 */
export interface AdminExchangeApiAdminExchangeControllerAdminPatchStatusRequest {
    /**
     * 
     * @type {AdminPatchStatusReqBodyDto}
     * @memberof AdminExchangeApiAdminExchangeControllerAdminPatchStatus
     */
    readonly adminPatchStatusReqBodyDto: AdminPatchStatusReqBodyDto
}

/**
 * Request parameters for adminGetExchange operation in AdminExchangeApi.
 * @export
 * @interface AdminExchangeApiAdminGetExchangeRequest
 */
export interface AdminExchangeApiAdminGetExchangeRequest {
    /**
     * 현재 페이지
     * @type {number}
     * @memberof AdminExchangeApiAdminGetExchange
     */
    readonly page?: number

    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof AdminExchangeApiAdminGetExchange
     */
    readonly limit?: number

    /**
     * 알림 상태
     * @type {'application' | 'waiting' | 'completed' | 'impossible'}
     * @memberof AdminExchangeApiAdminGetExchange
     */
    readonly status?: AdminGetExchangeStatusEnum

    /**
     * 시작 날짜
     * @type {string}
     * @memberof AdminExchangeApiAdminGetExchange
     */
    readonly startDate?: string

    /**
     * 끝 날짜
     * @type {string}
     * @memberof AdminExchangeApiAdminGetExchange
     */
    readonly endDate?: string

    /**
     * 정렬 기준
     * @type {'level' | 'exchangeableAmountBeforeRequest' | 'amountRequested' | 'tax' | 'amountBeExchanged' | 'createdAt' | 'balance' | 'exchangeAt'}
     * @memberof AdminExchangeApiAdminGetExchange
     */
    readonly sort?: AdminGetExchangeSortEnum

    /**
     * 정렬 순서
     * @type {'desc' | 'asc'}
     * @memberof AdminExchangeApiAdminGetExchange
     */
    readonly sortOrder?: AdminGetExchangeSortOrderEnum

    /**
     * 검색 타입
     * @type {'id' | 'name'}
     * @memberof AdminExchangeApiAdminGetExchange
     */
    readonly searchType?: AdminGetExchangeSearchTypeEnum

    /**
     * 검색어(뷰업 ID)
     * @type {string}
     * @memberof AdminExchangeApiAdminGetExchange
     */
    readonly keyword?: string
}

/**
 * Request parameters for adminGetExchangesXlsx operation in AdminExchangeApi.
 * @export
 * @interface AdminExchangeApiAdminGetExchangesXlsxRequest
 */
export interface AdminExchangeApiAdminGetExchangesXlsxRequest {
    /**
     * 알림 상태
     * @type {'application' | 'waiting' | 'completed' | 'impossible'}
     * @memberof AdminExchangeApiAdminGetExchangesXlsx
     */
    readonly status?: AdminGetExchangesXlsxStatusEnum

    /**
     * 시작 날짜
     * @type {string}
     * @memberof AdminExchangeApiAdminGetExchangesXlsx
     */
    readonly startDate?: string

    /**
     * 끝 날짜
     * @type {string}
     * @memberof AdminExchangeApiAdminGetExchangesXlsx
     */
    readonly endDate?: string

    /**
     * 검색 타입
     * @type {'id' | 'name'}
     * @memberof AdminExchangeApiAdminGetExchangesXlsx
     */
    readonly searchType?: AdminGetExchangesXlsxSearchTypeEnum

    /**
     * 검색어(뷰업 ID)
     * @type {string}
     * @memberof AdminExchangeApiAdminGetExchangesXlsx
     */
    readonly keyword?: string

    /**
     * 정렬 기준
     * @type {'level' | 'exchangeableAmountBeforeRequest' | 'amountRequested' | 'tax' | 'amountBeExchanged' | 'createdAt' | 'balance' | 'exchangeAt'}
     * @memberof AdminExchangeApiAdminGetExchangesXlsx
     */
    readonly sort?: AdminGetExchangesXlsxSortEnum

    /**
     * 정렬 순서
     * @type {'desc' | 'asc'}
     * @memberof AdminExchangeApiAdminGetExchangesXlsx
     */
    readonly sortOrder?: AdminGetExchangesXlsxSortOrderEnum
}

/**
 * Request parameters for adminPatchStatus operation in AdminExchangeApi.
 * @export
 * @interface AdminExchangeApiAdminPatchStatusRequest
 */
export interface AdminExchangeApiAdminPatchStatusRequest {
    /**
     * 
     * @type {AdminPatchStatusRequestDto}
     * @memberof AdminExchangeApiAdminPatchStatus
     */
    readonly adminPatchStatusRequestDto: AdminPatchStatusRequestDto
}

/**
 * AdminExchangeApi - object-oriented interface
 * @export
 * @class AdminExchangeApi
 * @extends {BaseAPI}
 */
export class AdminExchangeApi extends BaseAPI {
    /**
     * 
     * @summary 어드민 환급불가 사유 조회
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdminExchangeApi
     */
    public adminExchangeControllerAdminGetExchangeCancelCategories(options?: RawAxiosRequestConfig) {
        return AdminExchangeApiFp(this.configuration).adminExchangeControllerAdminGetExchangeCancelCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 환급 조회
     * @param {AdminExchangeApiAdminExchangeControllerAdminGetExchangesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdminExchangeApi
     */
    public adminExchangeControllerAdminGetExchanges(requestParameters: AdminExchangeApiAdminExchangeControllerAdminGetExchangesRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminExchangeApiFp(this.configuration).adminExchangeControllerAdminGetExchanges(requestParameters.page, requestParameters.limit, requestParameters.status, requestParameters.startDate, requestParameters.endDate, requestParameters.sort, requestParameters.sortOrder, requestParameters.searchType, requestParameters.keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 환급 로그 엑셀 다운로드
     * @param {AdminExchangeApiAdminExchangeControllerAdminGetExchangesXlsxRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdminExchangeApi
     */
    public adminExchangeControllerAdminGetExchangesXlsx(requestParameters: AdminExchangeApiAdminExchangeControllerAdminGetExchangesXlsxRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminExchangeApiFp(this.configuration).adminExchangeControllerAdminGetExchangesXlsx(requestParameters.status, requestParameters.startDate, requestParameters.endDate, requestParameters.searchType, requestParameters.keyword, requestParameters.sort, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 환급 상태 변경
     * @param {AdminExchangeApiAdminExchangeControllerAdminPatchStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdminExchangeApi
     */
    public adminExchangeControllerAdminPatchStatus(requestParameters: AdminExchangeApiAdminExchangeControllerAdminPatchStatusRequest, options?: RawAxiosRequestConfig) {
        return AdminExchangeApiFp(this.configuration).adminExchangeControllerAdminPatchStatus(requestParameters.adminPatchStatusReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 환급 조회 API
     * @param {AdminExchangeApiAdminGetExchangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminExchangeApi
     */
    public adminGetExchange(requestParameters: AdminExchangeApiAdminGetExchangeRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminExchangeApiFp(this.configuration).adminGetExchange(requestParameters.page, requestParameters.limit, requestParameters.status, requestParameters.startDate, requestParameters.endDate, requestParameters.sort, requestParameters.sortOrder, requestParameters.searchType, requestParameters.keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 환급불가 사유 조회 API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminExchangeApi
     */
    public adminGetExchangeCancelCategories(options?: RawAxiosRequestConfig) {
        return AdminExchangeApiFp(this.configuration).adminGetExchangeCancelCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 환급 로그 엑셀 다운로드 API
     * @param {AdminExchangeApiAdminGetExchangesXlsxRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminExchangeApi
     */
    public adminGetExchangesXlsx(requestParameters: AdminExchangeApiAdminGetExchangesXlsxRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminExchangeApiFp(this.configuration).adminGetExchangesXlsx(requestParameters.status, requestParameters.startDate, requestParameters.endDate, requestParameters.searchType, requestParameters.keyword, requestParameters.sort, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 환급 상태 변경 API
     * @param {AdminExchangeApiAdminPatchStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminExchangeApi
     */
    public adminPatchStatus(requestParameters: AdminExchangeApiAdminPatchStatusRequest, options?: RawAxiosRequestConfig) {
        return AdminExchangeApiFp(this.configuration).adminPatchStatus(requestParameters.adminPatchStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AdminExchangeControllerAdminGetExchangesStatusEnum = {
    Application: 'application',
    Waiting: 'waiting',
    Completed: 'completed',
    Impossible: 'impossible'
} as const;
export type AdminExchangeControllerAdminGetExchangesStatusEnum = typeof AdminExchangeControllerAdminGetExchangesStatusEnum[keyof typeof AdminExchangeControllerAdminGetExchangesStatusEnum];
/**
 * @export
 */
export const AdminExchangeControllerAdminGetExchangesSortEnum = {
    Level: 'level',
    ExchangeableAmountBeforeRequest: 'exchangeableAmountBeforeRequest',
    AmountRequested: 'amountRequested',
    Tax: 'tax',
    AmountBeExchanged: 'amountBeExchanged',
    CreatedAt: 'createdAt',
    Balance: 'balance',
    ExchangeAt: 'exchangeAt'
} as const;
export type AdminExchangeControllerAdminGetExchangesSortEnum = typeof AdminExchangeControllerAdminGetExchangesSortEnum[keyof typeof AdminExchangeControllerAdminGetExchangesSortEnum];
/**
 * @export
 */
export const AdminExchangeControllerAdminGetExchangesSortOrderEnum = {
    Desc: 'desc',
    Asc: 'asc'
} as const;
export type AdminExchangeControllerAdminGetExchangesSortOrderEnum = typeof AdminExchangeControllerAdminGetExchangesSortOrderEnum[keyof typeof AdminExchangeControllerAdminGetExchangesSortOrderEnum];
/**
 * @export
 */
export const AdminExchangeControllerAdminGetExchangesSearchTypeEnum = {
    Id: 'id',
    Name: 'name'
} as const;
export type AdminExchangeControllerAdminGetExchangesSearchTypeEnum = typeof AdminExchangeControllerAdminGetExchangesSearchTypeEnum[keyof typeof AdminExchangeControllerAdminGetExchangesSearchTypeEnum];
/**
 * @export
 */
export const AdminExchangeControllerAdminGetExchangesXlsxStatusEnum = {
    Application: 'application',
    Waiting: 'waiting',
    Completed: 'completed',
    Impossible: 'impossible'
} as const;
export type AdminExchangeControllerAdminGetExchangesXlsxStatusEnum = typeof AdminExchangeControllerAdminGetExchangesXlsxStatusEnum[keyof typeof AdminExchangeControllerAdminGetExchangesXlsxStatusEnum];
/**
 * @export
 */
export const AdminExchangeControllerAdminGetExchangesXlsxSearchTypeEnum = {
    Id: 'id',
    Name: 'name'
} as const;
export type AdminExchangeControllerAdminGetExchangesXlsxSearchTypeEnum = typeof AdminExchangeControllerAdminGetExchangesXlsxSearchTypeEnum[keyof typeof AdminExchangeControllerAdminGetExchangesXlsxSearchTypeEnum];
/**
 * @export
 */
export const AdminExchangeControllerAdminGetExchangesXlsxSortEnum = {
    Level: 'level',
    ExchangeableAmountBeforeRequest: 'exchangeableAmountBeforeRequest',
    AmountRequested: 'amountRequested',
    Tax: 'tax',
    AmountBeExchanged: 'amountBeExchanged',
    CreatedAt: 'createdAt',
    Balance: 'balance',
    ExchangeAt: 'exchangeAt'
} as const;
export type AdminExchangeControllerAdminGetExchangesXlsxSortEnum = typeof AdminExchangeControllerAdminGetExchangesXlsxSortEnum[keyof typeof AdminExchangeControllerAdminGetExchangesXlsxSortEnum];
/**
 * @export
 */
export const AdminExchangeControllerAdminGetExchangesXlsxSortOrderEnum = {
    Desc: 'desc',
    Asc: 'asc'
} as const;
export type AdminExchangeControllerAdminGetExchangesXlsxSortOrderEnum = typeof AdminExchangeControllerAdminGetExchangesXlsxSortOrderEnum[keyof typeof AdminExchangeControllerAdminGetExchangesXlsxSortOrderEnum];
/**
 * @export
 */
export const AdminGetExchangeStatusEnum = {
    Application: 'application',
    Waiting: 'waiting',
    Completed: 'completed',
    Impossible: 'impossible'
} as const;
export type AdminGetExchangeStatusEnum = typeof AdminGetExchangeStatusEnum[keyof typeof AdminGetExchangeStatusEnum];
/**
 * @export
 */
export const AdminGetExchangeSortEnum = {
    Level: 'level',
    ExchangeableAmountBeforeRequest: 'exchangeableAmountBeforeRequest',
    AmountRequested: 'amountRequested',
    Tax: 'tax',
    AmountBeExchanged: 'amountBeExchanged',
    CreatedAt: 'createdAt',
    Balance: 'balance',
    ExchangeAt: 'exchangeAt'
} as const;
export type AdminGetExchangeSortEnum = typeof AdminGetExchangeSortEnum[keyof typeof AdminGetExchangeSortEnum];
/**
 * @export
 */
export const AdminGetExchangeSortOrderEnum = {
    Desc: 'desc',
    Asc: 'asc'
} as const;
export type AdminGetExchangeSortOrderEnum = typeof AdminGetExchangeSortOrderEnum[keyof typeof AdminGetExchangeSortOrderEnum];
/**
 * @export
 */
export const AdminGetExchangeSearchTypeEnum = {
    Id: 'id',
    Name: 'name'
} as const;
export type AdminGetExchangeSearchTypeEnum = typeof AdminGetExchangeSearchTypeEnum[keyof typeof AdminGetExchangeSearchTypeEnum];
/**
 * @export
 */
export const AdminGetExchangesXlsxStatusEnum = {
    Application: 'application',
    Waiting: 'waiting',
    Completed: 'completed',
    Impossible: 'impossible'
} as const;
export type AdminGetExchangesXlsxStatusEnum = typeof AdminGetExchangesXlsxStatusEnum[keyof typeof AdminGetExchangesXlsxStatusEnum];
/**
 * @export
 */
export const AdminGetExchangesXlsxSearchTypeEnum = {
    Id: 'id',
    Name: 'name'
} as const;
export type AdminGetExchangesXlsxSearchTypeEnum = typeof AdminGetExchangesXlsxSearchTypeEnum[keyof typeof AdminGetExchangesXlsxSearchTypeEnum];
/**
 * @export
 */
export const AdminGetExchangesXlsxSortEnum = {
    Level: 'level',
    ExchangeableAmountBeforeRequest: 'exchangeableAmountBeforeRequest',
    AmountRequested: 'amountRequested',
    Tax: 'tax',
    AmountBeExchanged: 'amountBeExchanged',
    CreatedAt: 'createdAt',
    Balance: 'balance',
    ExchangeAt: 'exchangeAt'
} as const;
export type AdminGetExchangesXlsxSortEnum = typeof AdminGetExchangesXlsxSortEnum[keyof typeof AdminGetExchangesXlsxSortEnum];
/**
 * @export
 */
export const AdminGetExchangesXlsxSortOrderEnum = {
    Desc: 'desc',
    Asc: 'asc'
} as const;
export type AdminGetExchangesXlsxSortOrderEnum = typeof AdminGetExchangesXlsxSortOrderEnum[keyof typeof AdminGetExchangesXlsxSortOrderEnum];
